<div class="strength-meter strength-meter-height" [attr.data-strength-score]="score">
  <div class="strength-wrapper mt-2">
    <div class="strength-bars"></div>
  </div>
  <div class="card border-0">
    <div class="strength-feedback" >
      <i class="fa fa-check-circle " [ngClass]="status1?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Uppercaseandalowercase' | cxTranslate}}
    </div>
    <div class="strength-feedback" >
      <i class="fa fa-check-circle " [ngClass]="status2?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Minimum' | cxTranslate}}
    </div>
    <div class="strength-feedback" >
      <i class="fa fa-check-circle " [ngClass]="status3?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Specialcharacter' | cxTranslate}}
    </div>
    <div class="strength-feedback" *ngIf="currentLang === 'zh'">
      <i class="fa fa-check-circle " [ngClass]="status1?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Uppercaseandalowercase1' | cxTranslate}}
    </div>
    <div class="strength-feedback" *ngIf="currentLang === 'zh'">
      <i class="fa fa-check-circle " [ngClass]="status2?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Minimum1' | cxTranslate}}
    </div>
    <div class="strength-feedback" *ngIf="currentLang === 'zh'">
      <i class="fa fa-check-circle " [ngClass]="status3?'fa-check-circle text-success' : 'fa-check-circle text-secondary '" ></i>
      {{'home.toastErrorMessages.Specialcharacter1' | cxTranslate}}
    </div>

  </div>
</div>
